// extracted by css-extract-rspack-plugin
export default {"main":"WGzVVnAsd0xJBUiB","layout":"YcveX288J0Mj6dkY","header":"_mo47CPISg3db3gN"};